/* global I18n */

import React from "react"
import FaIcon from "components/fa_icon"
import {use_configuration} from "./configuration_provider"

function SliderControl({
  title,
  text,
  min,
  max,
  step,
  value,
  on_change
}) {
  const {configuration} = use_configuration()
  const {can_train, exam_conditions} = configuration
  const stepped_max = step * Math.ceil(max / step) || step
  const stepped_value = step * Math.ceil(value / step)
  const slider_color = exam_conditions ? "#FFC026" : "#0099FF"

  function handle_change(e) {
    const new_value = Number(e.target.value)
    if (new_value > max) {
      on_change(max)
    } else {
      on_change(new_value)
    }
  }

  const slider_background_style = {
    background: `linear-gradient(
      to right,
      ${slider_color} ${((stepped_value - min) / (stepped_max - min)) * 100}%,
      #D8D8D8 ${((stepped_value - min) / (stepped_max - min)) * 100}%
    )`
  }

  return (
    <div className="control-item">
      <div className="info">
        <h4 className="title">{title}</h4>
        <p className="description">{text}</p>
      </div>
      <div className="control slider">
        <div className="slider-values">
          <span className="slider-value min">{value}</span>
          <span className="slider-value max">{max}</span>
        </div>
        <input
          type="range"
          min={min}
          max={stepped_max}
          step={step}
          value={stepped_value}
          onChange={handle_change}
          style={{width: "100%", ...slider_background_style}}
        />
      </div>
      {!can_train &&
        <div className="preview-overlay">
          <span>
            <FaIcon name={"fa-lock"} text_aligned={true}/>
            {I18n.t("js.quiz_mode_selector.preview.settings")}
          </span>
        </div>
      }
    </div>
  )
}

export default SliderControl
